import * as React from 'react';
import * as ReactDOM from "react-dom";
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {CampusProofCard} from '../ProofEdit/CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {CampusCloseX} from '../Components/CampusCloseX';
import {DesignSelector} from '../DesignSelector/DesignSelector';

/* root for image */
declare var UploadRoot: string;
declare var AssetRoot: string;


const viewDimStyle: React.CSSProperties = {
    color:'#777777',
    cursor:'pointer',
    textAlign:'center',
    ':hover': {
        textDecoration:'underline'
    }
}
const designBox: React.CSSProperties = {
    height:'300px',
    marginTop:'20px'
}
const designImageStyle: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifLightItalic',
    color:'#626161',
    fontSize:'15px',
    margin:'auto',
}
const designImageStyle1: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifLightItalic',
    color:'#626161',
    fontSize:'15px',
    margin:'auto auto 120px auto',
    width:'85%'
}
const artNotes1: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'rgb(97, 96, 96)',
    textAlign:'center',
    fontSize:'12px',
    marginTop:'15px'
}
class ArtProps extends Tgcc.BaseProps{
    design: Tgcc.Design;
    uploads: any;
}

const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}

class _IndigoArtEdit extends React.Component<ArtProps, any>{

    openDesign = () => {browserHistory.push(Tgcc.Routes.IndigoDesignListView)};

    handleUploadDesign = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.UploadDesign})
    }

    canDisplayFile = (name: string) => {
        if(!name)
            return false;
        var test = name.toString().toUpperCase();
        return endsWith(test, '.JPG') || endsWith(test, '.PNG') || endsWith(test, '.TIF') || endsWith(test, '.SVG');
    }

    getImageSource = (fname: string, url: string) => {
        if(this.canDisplayFile(fname))
            return url;

        var test = fname.toString().toUpperCase();
        if(endsWith(test,".PSD"))
            return Tgcc.Styles.uploadImagePlaceholder.PSD;
        if(endsWith(test, ".PDF"))
            return Tgcc.Styles.uploadImagePlaceholder.PDF;
        if(endsWith(test, ".AI"))
            return Tgcc.Styles.uploadImagePlaceholder.AI;
    }
    getUploadsSrc = () => {
        var key = Object.keys(this.props.uploads)[0];
        return  UploadRoot + '/' + this.getImageSource(key, this.props.uploads[key]);
    }

    removeDesign = () => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateIndigoProofDesign, payload: null});
    }

    getDesignImage = () => {
        var contents = new Array();
        var uploadCt = this.props.uploads ? Object.keys(this.props.uploads).length : 0;
        
        if(this.props.design && uploadCt){
            var imgStyle = {maxWidth: '50%', maxHeight:'50%', alignSelf: 'center', marginBottom: '5px', position: 'relative'};
            var uploadStr = uploadCt > 1 ? 'uploads' : 'upload';
            var imagepath = Tgcc.getDesignPath(AssetRoot + this.props.design.thumbnail.replace(' ', '%20'));
            contents.push(<CampusCloseX key={2} closeAction={this.removeDesign} top="0px" right="100px" position="relative"/>);
            contents.push(<img key={3} src={imagepath} style={imgStyle} onError={Tgcc.handleDesignImageError}/>);
            contents.push(<div key={4}>plus {uploadCt} {uploadStr}</div>)
            contents.push(<CampusButton key={1} text="change design" onClick={this.openDesign} fontSize='10px'lineHeight='1.4em' margin='auto' backgroundColor="#DF735B" color="white" />);
        } else if(this.props.design){
            var imagepath = Tgcc.getDesignPath(AssetRoot + this.props.design.thumbnail.replace(' ', '%20'));
            var imgStyle = {maxWidth: '50%', maxHeight:'50%', alignSelf: 'center', marginBottom: '5px', position: 'relative'};
            contents.push(<CampusCloseX key={2} closeAction={this.removeDesign}  top="0px" right="100px" position="relative"/>);
            contents.push(<img key={3} src={imagepath} style={imgStyle} onError={Tgcc.handleDesignImageError}/>);
            contents.push(<CampusButton key={1} text="change design" onClick={this.openDesign} fontSize='10px'lineHeight='3em' margin='auto' backgroundColor="#DF735B" color="white"/>);
        } else if(uploadCt){
            var uploadStr = uploadCt > 1 ? 'total uploads' : 'upload';
            var imagePath = this.getUploadsSrc();
            var imgStyle = {maxWidth: '50%', maxHeight:'50%', alignSelf: 'center', marginBottom: '5px', position: 'relative'};
            contents.push(<img key={2} src={imagePath} style={imgStyle}onError={Tgcc.handleDesignImageError} />);
            contents.push(<div key={3}>{uploadCt} {uploadStr}</div>)
            contents.push(<CampusButton key={1} text="Browse our designs" onClick={this.openDesign} fontSize="10px" lineHeight="3em" margin='auto' backgroundColor="#DF735B" color="white"/>);
        } else {
            contents.push(<CampusButton key={1} text="Browse our Designs" onClick={this.openDesign} fontSize="10px" lineHeight="3em" margin='auto' backgroundColor="#DF735B" color="white"/>);
        }
        return contents;
    }
    checkDesign(){
        if(!this.props.design && !this.props.uploads){
            return(<div>
                        <div style={artNotes1}>Preferred file types: .ai, .eps, .pdf, .psd</div>
                    </div>)
        }
    }
    render(){    
        let designImage = this.getDesignImage();   
        return (
        <div>
            <CampusProofCard title="1. Create">
            <CampusButton text="Upload Your Files" onClick={this.handleUploadDesign} fontSize='10px' margin='30px 0px 5px' lineHeight='3em' backgroundColor="#DF735B" color="white"/>
            {this.checkDesign()}
            {designImage}
            </CampusProofCard>
        </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { 
        design: state.ActiveProof.design,
        uploads: state.ActiveProof.uploadedFiles
    };
};
export var IndigoArtEdit = connect(mapStateToProps)(_IndigoArtEdit);
